"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6023],{

/***/ 78034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ CartSummary; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/components/ApplePayButton.tsx
var ApplePayButton = __webpack_require__(74503);
// EXTERNAL MODULE: ./ui/components/PriceBreakdown.tsx + 1 modules
var PriceBreakdown = __webpack_require__(10796);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ./utils/isNumber.ts
var isNumber = __webpack_require__(95442);
// EXTERNAL MODULE: ./ui/components/Price.tsx
var Price = __webpack_require__(81406);
;// CONCATENATED MODULE: ./ui/components/CartAppliedPromotions.tsx






var CartAppliedPromotions = function(props) {
    var _adjustments, _adjustments1;
    var cart = props.cart, className = props.className;
    var adjustments = [];
    //Should show only order/shipping lvl promotions and not coupon based
    (cart === null || cart === void 0 ? void 0 : cart.orderAdjustments) && (_adjustments = adjustments).push.apply(_adjustments, (0,_to_consumable_array/* default */.Z)(cart.orderAdjustments.filter(function(p) {
        return !p.couponCode;
    })));
    (cart === null || cart === void 0 ? void 0 : cart.shippingAdjustments) && (_adjustments1 = adjustments).push.apply(_adjustments1, (0,_to_consumable_array/* default */.Z)(cart.shippingAdjustments.filter(function(p) {
        return !p.couponCode;
    })));
    if (!adjustments.length) {
        return null;
    }
    var adjustmentsFiltered = adjustments.filter(function(adj) {
        return adj.promotionId !== "codFee";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,twind.tw)("font-bold text-puma-black-100", className),
        children: adjustmentsFiltered.map(function(param) {
            var promotionId = param.promotionId, itemText = param.itemText, price = param.price;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                "data-test-id": "cart-applied-promotion",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "flex justify-between whitespace-nowrap normal-case font-normal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "whitespace-normal",
                            "data-test-id": "cart-applied-promo-callout",
                            children: itemText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-puma-green",
                            "data-test-id": "cart-applied-promo-adjustment",
                            children: (0,isNumber/* isNumber */.h)(price) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                amount: price
                            })
                        })
                    ]
                })
            }, promotionId);
        })
    });
};

// EXTERNAL MODULE: ./ui/components/AfterpayOrKlarnaText.tsx + 1 modules
var AfterpayOrKlarnaText = __webpack_require__(72026);
// EXTERNAL MODULE: ./ui/elements/AlertMessage.tsx
var AlertMessage = __webpack_require__(66224);
// EXTERNAL MODULE: ./ui/components/GooglePayButton.tsx
var GooglePayButton = __webpack_require__(69192);
// EXTERNAL MODULE: ./utils/isCartInStock.ts
var isCartInStock = __webpack_require__(9688);
// EXTERNAL MODULE: ./ui/components/PayPalButton.tsx
var PayPalButton = __webpack_require__(49246);
// EXTERNAL MODULE: ./ui/components/AmazonPayButton.tsx
var AmazonPayButton = __webpack_require__(91574);
// EXTERNAL MODULE: ./ui/components/TermsAndConditions.tsx + 3 modules
var TermsAndConditions = __webpack_require__(99750);
// EXTERNAL MODULE: ./ui/components/TermsAndConditionsBackup.tsx
var TermsAndConditionsBackup = __webpack_require__(95459);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./utils/longTermPreOrder.ts
var longTermPreOrder = __webpack_require__(50765);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./utils/dynamicYield.ts
var dynamicYield = __webpack_require__(64907);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ./ui/components/AdyenApplePayButton.tsx
var AdyenApplePayButton = __webpack_require__(64844);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/utils/isTherePromosButNotASinglePromoClaimed.ts
var isTherePromosButNotASinglePromoClaimed = __webpack_require__(11222);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/OldDesign/index.tsx + 16 modules
var OldDesign = __webpack_require__(12656);
// EXTERNAL MODULE: ./utils/isAppOnlyProductItem.ts
var isAppOnlyProductItem = __webpack_require__(62687);
// EXTERNAL MODULE: ./utils/isAppExclusiveValidRange.ts
var isAppExclusiveValidRange = __webpack_require__(22649);
// EXTERNAL MODULE: ./utils/getAppOnlyDateTimes.ts
var getAppOnlyDateTimes = __webpack_require__(75169);
// EXTERNAL MODULE: ./ui/components/ShoppingCartItem/index.tsx + 2 modules
var ShoppingCartItem = __webpack_require__(65733);
;// CONCATENATED MODULE: ./ui/components/CartItems.tsx








var CartItems = function(param) {
    var basketId = param.basketId, condensedView = param.condensedView, editableItems = param.editableItems, preventItemLinks = param.preventItemLinks, _products = param.products, products = _products === void 0 ? [] : _products, errorHandling = param.errorHandling;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,react.useState)(false), updating = ref[0], setUpdating = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        id: "cart-products",
        className: "flex flex-col flex-grow",
        "aria-label": translate("productList"),
        children: products === null || products === void 0 ? void 0 : products.map(function(cartItem) {
            var isBonusItem = !!(cartItem.__typename === "ProductCartItem" && cartItem.bonusItemId);
            var isForAppItem = (0,isAppOnlyProductItem/* isAppOnlyProductItem */.b)(cartItem);
            var ref = (0,getAppOnlyDateTimes/* getAppOnlyDateTimes */.r)(cartItem), from = ref.from, to = ref.to;
            var allowUpdate = editableItems && !isBonusItem && !(0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isForAppItem, from, to);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (0,twind.tw)([
                    "mobile:pt-0",
                    condensedView && "-mt-[1px] pt-0",
                    !condensedView && "pt-4", 
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartItem/* ShoppingCartItem */.y, {
                    compact: true,
                    item: cartItem,
                    basketId: basketId,
                    allowRemove: editableItems,
                    preventItemLinks: preventItemLinks,
                    allowUpdate: allowUpdate,
                    errorHandling: errorHandling,
                    updating: updating,
                    setUpdating: function(v) {
                        return setUpdating(v);
                    }
                })
            }, cartItem.id);
        })
    });
};

// EXTERNAL MODULE: ./ui/elements/Accordion.tsx
var Accordion = __webpack_require__(36998);
;// CONCATENATED MODULE: ./ui/components/CartSummary/CartSummaryAccordion.tsx



var CartSummaryAccordion = function(param) {
    var bodyClassNameConfig = param.bodyClassNameConfig, children = param.children, className = param.className, dataTestId = param.dataTestId, _expanded = param.expanded, expanded = _expanded === void 0 ? true : _expanded, headerClassNameConfig = param.headerClassNameConfig, id = param.id, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionRoot */.c2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionTab */.US, {
            className: className,
            dataTestId: dataTestId,
            expand: expanded,
            headerClassNameConfig: headerClassNameConfig,
            bodyClassNameConfig: bodyClassNameConfig,
            id: id,
            title: title,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
;// CONCATENATED MODULE: ./ui/components/CartSummary/GroupedCartItemsTitle.tsx



var formatTitle = function(param) {
    var group = param.group, translate = param.translate, locale = param.locale;
    switch(group){
        case "unavailable":
            return "".concat(translate("estimatedArrival"), ": ").concat(translate("dateUnavailable"));
        case "giftCards":
            return translate("digitalGiftCardSectionLabel");
        default:
            var endDate = group ? new Date("".concat(group.split("T")[0], "T00:00")) : new Date();
            var estimatedArrivalDate = new Intl.DateTimeFormat(locale, {
                month: "short",
                day: "numeric"
            }).format(endDate);
            return "".concat(translate("estimatedArrival"), ": ").concat(estimatedArrivalDate);
    }
};
var GroupedCartItemsTitle = function(param) {
    var group = param.group;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var locale = (0,useSiteConfig/* useSiteConfig */.N)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: "text-puma-green font-bold bg-puma-black-700 p-2 pl-4 text-sm uppercase mt-4 mb-0",
        children: formatTitle({
            group: group,
            translate: translate,
            locale: locale
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/CartSummary/GroupedCartItems.tsx






var SortDirection;
(function(SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection || (SortDirection = {}));
var sortByEstimatedDeliveryDates = function(productMap) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : SortDirection.ASC;
    var sorted = [
        (0,_to_consumable_array/* default */.Z)(productMap.entries()).sort(function(param, param1) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), a = _param[0], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 1), b = _param1[0];
            var dateA = Date.parse(a);
            var dateB = Date.parse(b);
            if (isNaN(dateA) || isNaN(dateB)) return 1;
            return sortDirection === SortDirection.DESC ? dateB - dateA : dateA - dateB;
        }), 
    ];
    return _construct(Map, (0,_to_consumable_array/* default */.Z)(sorted));
};
var groupCartItemsByDeliveryDate = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, sortDirection = param.sortDirection;
    var itemMap = new Map();
    var giftCards = [];
    var unavailableEddProducts = [];
    // Group products by eddEnd date using the itemMap
    items.forEach(function(item) {
        if ("estimatedDeliveryDate" in item) {
            var ref;
            var eddEnd = (ref = item.estimatedDeliveryDate) === null || ref === void 0 ? void 0 : ref.eddEnd;
            // If eddEnd exists & date is already in itemMap, add the product
            if (eddEnd && itemMap.has(eddEnd)) {
                itemMap.set(eddEnd, (0,_to_consumable_array/* default */.Z)(itemMap.get(eddEnd)).concat([
                    item
                ]));
            } else if (eddEnd && !itemMap.has(eddEnd)) {
                itemMap.set(eddEnd, [
                    item
                ]);
            } else {
                unavailableEddProducts.push(item);
            }
        } else if ("senderName" in item) {
            giftCards.push(item);
        } else {
            unavailableEddProducts.push(item);
        }
    });
    // Sort cart items by eddEnd date (the key) & add unavailable and gift card items
    var sortedCartItems = sortByEstimatedDeliveryDates(itemMap, sortDirection);
    if (unavailableEddProducts.length) {
        sortedCartItems.set("unavailable", unavailableEddProducts);
    }
    if (giftCards.length) {
        sortedCartItems.set("giftCards", giftCards);
    }
    return sortedCartItems;
};
var GroupedCartItems = function(param) {
    var basketId = param.basketId, _products = param.products, products = _products === void 0 ? [] : _products, editableItems = param.editableItems, preventItemLinks = param.preventItemLinks;
    var ref;
    var groupedItems = groupCartItemsByDeliveryDate({
        items: products
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ref = (0,_to_consumable_array/* default */.Z)(groupedItems === null || groupedItems === void 0 ? void 0 : groupedItems.entries())) === null || ref === void 0 ? void 0 : ref.map(function(group) {
            var groupKey = group[0];
            var groupProducts = group[1];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupedCartItemsTitle, {
                        group: groupKey
                    }),
                    (groupProducts === null || groupProducts === void 0 ? void 0 : groupProducts.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItems, {
                        basketId: basketId,
                        condensedView: true,
                        editableItems: editableItems,
                        preventItemLinks: preventItemLinks,
                        products: groupProducts
                    }) : null
                ]
            }, groupKey);
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/CartSummary/CartProductSummary.tsx






var CartProductSummary = function(param) {
    var basketId = param.basketId, editableItems = param.editableItems, preventItemLinks = param.preventItemLinks, _products = param.products, products = _products === void 0 ? [] : _products, showEstimatedDeliveryDate = param.showEstimatedDeliveryDate, errorHandling = param.errorHandling;
    var isOrderDetailsCollapsedByDefault = (0,useFeature/* useFeature */.S)("CHECKOUT_ACCORDION_COLLAPSED_BY_DEFAULT");
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var accordionTitle = translate("checkoutCartSummaryTitle", {
        cartCount: products === null || products === void 0 ? void 0 : products.length
    });
    var headerClassNameConfig = {
        baseClassName: "text-base sm:text-xl bg-puma-black-700 p-4 uppercase",
        expanded: "pb-4 pl-4",
        closed: "pb-4 pl-4 mb-6"
    };
    var bodyClassNameConfig = {
        baseClassName: "pb-6"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartSummaryAccordion, {
        id: "summary-products",
        dataTestId: "summary-products",
        title: accordionTitle,
        headerClassNameConfig: headerClassNameConfig,
        bodyClassNameConfig: bodyClassNameConfig,
        expanded: !isOrderDetailsCollapsedByDefault,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            "aria-labelledby": "cart-summary-products-title",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "sr-only",
                    id: "cart-summary-products-title",
                    children: translate("shoppingCart")
                }),
                showEstimatedDeliveryDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupedCartItems, {
                    basketId: basketId,
                    editableItems: editableItems,
                    preventItemLinks: preventItemLinks,
                    products: products
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItems, {
                    basketId: basketId,
                    editableItems: editableItems,
                    preventItemLinks: preventItemLinks,
                    products: products,
                    errorHandling: errorHandling
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./utils/extractError.ts
var extractError = __webpack_require__(4360);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./hooks/useValidation.ts + 1 modules
var useValidation = __webpack_require__(70750);
// EXTERNAL MODULE: ./ui/elements/Button.tsx + 1 modules
var Button = __webpack_require__(70868);
;// CONCATENATED MODULE: ./ui/components/CartSummary/PromoCodeSection.tsx




















var PromoCodeSection = function(param) {
    var cart = param.cart, setCouponIsFetching = param.setCouponIsFetching;
    var ref, ref1;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useValidation/* useValidation */.V)(), 1), validate = ref2[0];
    var isMobile = (0,media/* getIsMobile */.W)();
    var router = (0,next_router.useRouter)();
    var promoCodeExpandedOnMobile = (0,useFeature/* useFeature */.S)("CART_SUMMARY_PROMO_CODE_EXPANDED_ON_MOBILE");
    var promoCodeExpandedOnDesktopTablet = (0,useFeature/* useFeature */.S)("PROMO_CODE_ACCORDION_EXPANDED_BY_DEFAULT");
    var showDiscountAmountAndTextEnabled = (0,useFeature/* useFeature */.S)("SHOW_DISCOUNT_AMOUNT_AND_TEXT_ENABLED");
    var selectedPromoCode = (0,react.useMemo)(function() {
        var pathname = router.pathname;
        return pathname.includes("/checkout") ? analytics/* FormType.CHECKOUT */.dm.CHECKOUT : analytics/* FormType.CART_PROMO */.dm.CART_PROMO;
    }, [
        router.pathname
    ]);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useAddCouponToCartMutation */.RJP)(), 2), addCouponToCartResult = ref3[0], addCouponToCart = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRemoveCouponFromCartMutation */.Ymk)(), 2), removeCouponFromCartResult = ref4[0], removeCouponCode = ref4[1];
    (0,react.useEffect)(function() {
        if (addCouponToCartResult.fetching || removeCouponFromCartResult.fetching) {
            setCouponIsFetching(true);
        } else setCouponIsFetching(false);
    }, [
        addCouponToCartResult.fetching,
        setCouponIsFetching,
        removeCouponFromCartResult.fetching, 
    ]);
    var expandedOnInitialLoad = isMobile ? promoCodeExpandedOnMobile : promoCodeExpandedOnDesktopTablet;
    var couponCodeForm = (0,index_esm/* useForm */.cI)();
    var ref5 = (0,react.useState)(undefined), removing = ref5[0], setRemoving = ref5[1];
    var addError = (0,react.useMemo)(function() {
        var errorCode = (0,extractError/* extractCode */.N)(addCouponToCartResult);
        if (!errorCode) return;
        var ref;
        return (ref = (0,extractError/* extractError */.d)(addCouponToCartResult)) !== null && ref !== void 0 ? ref : t("addCouponCodeUserInputError") // Fallback in case we don't get a message from the server
        ;
    }, [
        addCouponToCartResult,
        t
    ]);
    var removeError = (0,react.useMemo)(function() {
        var errorCode = (0,extractError/* extractCode */.N)(removeCouponFromCartResult);
        if (!errorCode) return;
        switch(errorCode){
            case graphql/* GraphQlError.BadUserInput */.lNJ.BadUserInput:
                return t("removeCouponCodeUserInputError");
            default:
                return t("removeCouponCodeGenericError");
        }
    }, [
        removeCouponFromCartResult,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartSummaryAccordion, {
        dataTestId: "promo-code-container-accordion",
        id: "promo-code-accordion",
        title: t("promoCodePlaceholder"),
        headerClassNameConfig: {
            baseClassName: "text-base sm:text-xl bg-puma-black-700 p-4 uppercase",
            expanded: "pb-4 pl-4",
            closed: "pb-4 pl-4 mb-6"
        },
        bodyClassNameConfig: {
            baseClassName: "pt-4 mb-6"
        },
        expanded: expandedOnInitialLoad,
        className: "bg-puma-black-700 p-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "promo-code-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    "data-test-id": "promo-code-form",
                    onSubmit: couponCodeForm.handleSubmit(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                            var _tmp, operationResult, _tmp1, errorCode, errorMessage;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = {};
                                        // Add Google Analytics event to capture promo code
                                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PROMO_CODE_SUBMITTED */._q.PROMO_CODE_SUBMITTED, (_tmp["promo code"] = data.promoCode.toLowerCase(), _tmp));
                                        _tmp1 = {};
                                        return [
                                            4,
                                            addCouponToCart((_tmp1.input = {
                                                code: data.promoCode,
                                                basketId: cart === null || cart === void 0 ? void 0 : cart.id
                                            }, _tmp1))
                                        ];
                                    case 1:
                                        operationResult = _state.sent();
                                        errorCode = (0,extractError/* extractCode */.N)(operationResult);
                                        errorMessage = (0,extractError/* extractError */.d)(operationResult);
                                        if (errorCode && errorMessage) {
                                            (0,analytics/* formErrorEvent */.pd)(selectedPromoCode, [
                                                errorCode
                                            ]);
                                            return [
                                                2
                                            ];
                                        }
                                        couponCodeForm.reset();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(data) {
                            return _ref.apply(this, arguments);
                        };
                    }()),
                    className: "flex space-x-2 w-full mb-4",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                            id: "promo-code",
                            "data-test-id": "promo-code",
                            name: "promoCode",
                            showLabel: false,
                            label: t("promoCodeLabel"),
                            placeholder: t("promoCodeLabel"),
                            ref: couponCodeForm.register({
                                validate: validate.safeInput,
                                required: t("requiredField")
                            }),
                            errorText: addError || removeError || ((ref = couponCodeForm.errors) === null || ref === void 0 ? void 0 : (ref1 = ref.promoCode) === null || ref1 === void 0 ? void 0 : ref1.message),
                            crossOrigin: undefined
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            label: t("apply"),
                            disabled: !couponCodeForm.watch("promoCode") || addCouponToCartResult.fetching,
                            loading: addCouponToCartResult.fetching,
                            type: "submit",
                            size: "lg",
                            dataTestId: "apply-coupon-code"
                        })
                    ]
                }),
                ((cart === null || cart === void 0 ? void 0 : cart.couponItems) || []).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-test-id": "promo-code-accepted-container",
                    className: "flex flex-col items-center border rounded font-bold divide-y text-sm",
                    children: cart === null || cart === void 0 ? void 0 : cart.couponItems.map(function(coupon) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            "data-test-id": "coupon-".concat(coupon.couponItemId),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full p-3 rounded",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center space-x-3 justify-between ",
                                            children: [
                                                coupon.statusCode === "applied" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                    name: "check",
                                                    size: "xl",
                                                    fill: "success",
                                                    dataTestId: "promo-code-tick-icon"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                    name: "exclamation-outline",
                                                    size: "xl",
                                                    color: "error"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    "data-test-id": "promo-code-text",
                                                    className: (0,twind.tw)("flex flex-wrap space-x-3", coupon.statusCode !== "applied" && "text-puma-red"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: coupon.code
                                                        }),
                                                        showDiscountAmountAndTextEnabled && (0,isNumber/* isNumber */.h)(coupon.discountAmount) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-puma-green",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* Price */.t, {
                                                                amount: coupon.discountAmount
                                                            })
                                                        })
                                                    ]
                                                }),
                                                coupon.statusCode !== "applied" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-puma-red",
                                                    children: t("notApplicable")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            dataTestId: "remove-coupon-code",
                                            label: t("removeCoupon"),
                                            variant: "link",
                                            disabled: !!removing,
                                            loading: !!removing && removing === coupon.couponItemId,
                                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                var _tmp;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (!coupon.couponItemId) return [
                                                                3,
                                                                2
                                                            ];
                                                            setRemoving(coupon.couponItemId);
                                                            _tmp = {};
                                                            return [
                                                                4,
                                                                removeCouponCode((_tmp.input = {
                                                                    basketId: cart === null || cart === void 0 ? void 0 : cart.id,
                                                                    couponItemId: coupon.couponItemId
                                                                }, _tmp))
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            setRemoving(undefined);
                                                            _state.label = 2;
                                                        case 2:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }),
                                            children: t("remove")
                                        })
                                    ]
                                }),
                                coupon.calloutMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "p-3 pt-1 normal-case font-normal",
                                    "data-test-id": "promo-callout-message",
                                    children: coupon.calloutMessage
                                })
                            ]
                        }, coupon.couponItemId);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/CartSummary/CartSummary.tsx




























var CartSummary = function(param) {
    var cartResult = param.cartResult, editableItems = param.editableItems, preventItemLinks = param.preventItemLinks, showCheckoutLinks = param.showCheckoutLinks, showEstimatedDeliveryDate = param.showEstimatedDeliveryDate, showItemSummary = param.showItemSummary, showReturnShippingAlert = param.showReturnShippingAlert, errorHandling = param.errorHandling;
    var ref, ref1, ref2;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), injectDynamicYieldScripts = ref3.staticFeatures.injectDynamicYieldScripts;
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    var displayPromoDiscountBreakdown = (0,useFeature/* useFeature */.S)("DISPLAY_PROMO_DISCOUNT_BREAKDOWN");
    var isGiftWithPurchaseNewDesign = (0,useFeature/* useFeature */.S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    var ref4 = (0,react.useState)(false), couponIsFetching = ref4[0], setCouponIsFetching = ref4[1];
    var router = (0,next_router.useRouter)();
    var cart = (ref = cartResult.data) === null || ref === void 0 ? void 0 : ref.activeCart;
    if (!cart) return null;
    var mixedCartNotAllowed = cart.basketInStockStatus === constants/* BASKET_STOCK_STATUS.MIXED */.cU.MIXED && cart.isMixedCartAllowed === false;
    var canProceedToPayment = !cart.hasOfflineProducts && (0,isCartInStock/* isCartInStock */.c)(cartResult) && !couponIsFetching && !mixedCartNotAllowed && (!(errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.cartUpdateError) || (errorHandling === null || errorHandling === void 0 ? void 0 : (ref1 = errorHandling.cartUpdateError) === null || ref1 === void 0 ? void 0 : ref1.length) <= 0) && (!(errorHandling === null || errorHandling === void 0 ? void 0 : errorHandling.cartUpdateWarnings) || (errorHandling === null || errorHandling === void 0 ? void 0 : (ref2 = errorHandling.cartUpdateWarnings) === null || ref2 === void 0 ? void 0 : ref2.length) <= 0);
    var estimatedTotal = cart.estimatedTotal, giftWithPurchases = cart.giftWithPurchases, products = cart.products;
    var showAmazonPayButton = !cartResult.fetching && !cartResult.error && !mixedCartNotAllowed && (!(0,longTermPreOrder/* isLongTermPreOrder */.j)(cart) || (0,longTermPreOrder/* isLongTermPreOrderPaymentMethod */.L)(cart, constants/* PaymentMethod.AMAZON_PAY */.XL.AMAZON_PAY));
    var isEstimate = !router.pathname.includes("checkout/payment");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-test-id": "cart-summary",
        children: [
            showItemSummary && !!products.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductSummary, {
                basketId: cart.id,
                editableItems: editableItems,
                preventItemLinks: preventItemLinks,
                products: cart.products,
                errorHandling: errorHandling,
                showEstimatedDeliveryDate: showEstimatedDeliveryDate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoCodeSection, {
                cart: cart,
                setCouponIsFetching: setCouponIsFetching
            }),
            showReturnShippingAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-y border-puma-black-500 py-4 mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertMessage/* AlertMessage */.g, {
                    icon: "loop-forward",
                    children: translate("returnShipping")
                })
            }),
            !isGiftWithPurchaseNewDesign && (0,isTherePromosButNotASinglePromoClaimed/* isTherePromosButNotASinglePromoClaimed */.Q)({
                giftWithPurchases: giftWithPurchases
            }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(OldDesign/* GWPOldDesign.CalloutButton */.f.CalloutButton, {
                className: "w-full mb-6",
                onClick: function() {
                    return setModalOpen("GWPModal", true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "price-breakdown-container",
                children: [
                    displayPromoDiscountBreakdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartAppliedPromotions, {
                        cart: cart,
                        className: "mb-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceBreakdown/* PriceBreakdown */.$, {
                        cart: cart,
                        isEstimate: isEstimate
                    }),
                    (0,isNumber/* isNumber */.h)(estimatedTotal) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AfterpayOrKlarnaText/* AfterpayOrKlarnaText */.y, {
                            amount: estimatedTotal
                        })
                    }),
                    showCheckoutLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full space-y-3 mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TermsAndConditions/* default */.Z, {
                            page: "tacOnCartPage",
                            backupContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsBackup/* default */.Z, {}),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkCta */.NIR, {
                                    href: "checkout",
                                    bleed: true,
                                    size: "lg",
                                    dataTestId: "cart-summary-checkout",
                                    dimmed: !canProceedToPayment,
                                    onClick: function(e) {
                                        if (!canProceedToPayment) {
                                            e.preventDefault();
                                            return false;
                                        }
                                        injectDynamicYieldScripts && (0,dynamicYield/* dyCheckoutStartedEvent */.wB)();
                                    },
                                    label: translate("checkout")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdyenApplePayButton/* AdyenApplePayButton */.D, {
                                    disabled: !canProceedToPayment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayPalButton/* PayPalButton */.q, {
                                    disabled: !canProceedToPayment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton/* ApplePayButton */.x, {
                                    disabled: !canProceedToPayment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePayButton/* GooglePayButton */.I, {
                                    buttonType: "pay",
                                    disabled: !canProceedToPayment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: showAmazonPayButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(AmazonPayButton/* AmazonPayButton */.W, {
                                        disabled: !canProceedToPayment
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/CartSummary/index.ts



/***/ }),

/***/ 75169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getAppOnlyDateTimes; }
/* harmony export */ });
var getAppOnlyDateTimes = function(cartItem) {
    if (cartItem.__typename === "ProductCartItem") {
        return {
            from: cartItem.product.appOnlyDateTimeFrom,
            to: cartItem.product.appOnlyDateTimeTo
        };
    }
    return {
        from: null,
        to: null
    };
};


/***/ }),

/***/ 62687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isAppOnlyProductItem; }
/* harmony export */ });
var isAppOnlyProductItem = function(item) {
    return item.__typename === "ProductCartItem" && !!item.product.isAppExclusive;
};


/***/ }),

/***/ 13583:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);